import { connect } from 'react-redux';
import { selectors as userSelectors } from 'dux/user';
import { selectors as instanceSelectors } from 'dux/instances';
import { actionCreators } from '../../dux/instances';
import DatabaseList from './DatabaseList';

const mapStateToProps = (state) => ({
  userRoles: userSelectors.getIdentityState(state).roles,
  instanceDatabaseIsLoading: instanceSelectors.instanceDatabaseIsLoadingSelector(state),
});

const mapDispatchToProps = {
  deleteInstanceDatabase: actionCreators.deleteInstanceDatabase,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatabaseList);
